import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { AuthService } from '../services/auth.service';
import { SKIP_AUTH } from './auth-context';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const auth = inject(AuthService);
  const skipAuth = req.context.get(SKIP_AUTH);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let message = 'An unexpected error occurred';

      if (error.status === 0) {
        message = 'Unable to connect to server. Please check your connection.';
      } else if (error.status === 401) {
        message = error.error?.message || 'Session expired. Please login again.';
        if (!skipAuth) {
          auth.logout();
        }
      } else if (error.status === 403) {
        message = 'You do not have permission to perform this action.';
      } else if (error.status === 404) {
        message = error.error?.message || 'Resource not found.';
      } else if (error.status === 409) {
        message = error.error?.message || 'Conflict: Resource already exists.';
      } else if (error.status >= 500) {
        message = 'Server error. Please try again later.';
      } else if (error.error?.message) {
        message = error.error.message;
      }

      if (!skipAuth) {
        toast.error(message);
      }
      return throwError(() => error);
    }),
  );
};
